const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/room-events`;

/* Fire-and-forget shopper analytics: which room styles get picked / shared */
export const trackRoomEvent = (event, colorId, room, productType) => {
  if (!colorId) return;
  fetch(API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event, color_id: colorId, room: room || null, product_type: productType || null }),
    keepalive: true,
  }).catch(() => {});
};
